/**
 * RU-локализованные форматтеры дат для вкладки «Оплаты».
 *
 * На проводе даты — ymd-строки (YYYY-MM-DD, локальная календарная дата) либо ISO datetime
 * (события/история). Парсим их аккуратно, без сдвига таймзоны для чистых ymd.
 */

import { format, isToday, isTomorrow, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';

/** Разбор ymd (YYYY-MM-DD) в локальную дату без UTC-сдвига (важно для отображения плановых дат). */
export function parseYmd(ymd: string): Date {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ymd);
  if (m) {
    const [, y, mo, d] = m;
    return new Date(Number(y), Number(mo) - 1, Number(d));
  }
  return parseISO(ymd);
}

/** Date → ymd-строка (YYYY-MM-DD) в локальном календаре. */
export function toYmd(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

/** ymd | null → "dd.MM.yyyy" | "—". */
export function fmtDate(ymd: string | null | undefined): string {
  if (!ymd) return '—';
  return format(parseYmd(ymd), 'dd.MM.yyyy', { locale: ru });
}

/** ISO datetime → "dd.MM.yyyy HH:mm". */
export function fmtDateTime(iso: string): string {
  return format(parseISO(iso), 'dd.MM.yyyy HH:mm', { locale: ru });
}

/** ymd → «сегодня» | «завтра» | "dd.MM.yyyy" (для карточки «Ближайший»). */
export function relDay(ymd: string): string {
  const d = parseYmd(ymd);
  if (isToday(d)) return 'сегодня';
  if (isTomorrow(d)) return 'завтра';
  return format(d, 'd MMMM', { locale: ru });
}

/** Сегодняшняя календарная дата в ymd. */
export function todayYmd(): string {
  return toYmd(new Date());
}
